export enum PermissionLevel {
  PUBLIC = 'PUBLIC',
  ACCOUNTMEMBER = 'ACCOUNTMEMBER',
  CSMEMBER = 'CSMEMBER',
  SUPERADMIN = 'SUPERADMIN',
}

export const permissionHierarchyOrder = [
  PermissionLevel.PUBLIC,
  PermissionLevel.ACCOUNTMEMBER,
  PermissionLevel.CSMEMBER,
  PermissionLevel.SUPERADMIN,
];

// Ascending
export const permissionHierarchy = Object.fromEntries(permissionHierarchyOrder.map((v, i) => [v, i] as const)) as {
  [K in PermissionLevel]: number;
};

export const validPermissions = (minimum: PermissionLevel) => {
  return permissionHierarchyOrder.slice(permissionHierarchy[minimum]);
};

export const assertPermissionLevel = (minimum: PermissionLevel, level: PermissionLevel) => {
  if (!validPermissions(minimum).includes(level)) {
    throw new Error('Permission denied');
  }
};
